const ComponentLoader = () => (
  <div className="component-loader">
    <div className="loader" />
  </div>
);

export default ComponentLoader;
